import Discover from './discover.vue'
export default Discover